import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL/index'
import SystemProcessesPageAPI from 'containers/SystemProcesses/Table/layers/API'
import SystemProcesses from 'components/PageComponents/Settings/SystemProcesses'
// types
import { SystemProcessObject } from 'types/graphql'

const SystemProcessesContainer: React.FC = () => (
  <TableManagementProvider
    initialFilter={{
      objects: [
        SystemProcessObject.Action,
        SystemProcessObject.Kpi,
        SystemProcessObject.Objective,
        SystemProcessObject.Plan
      ]
    }}>
    <SystemProcessesPageAPI>
      <SystemProcesses />
    </SystemProcessesPageAPI>
  </TableManagementProvider>
)

export default SystemProcessesContainer
